module.exports = __webpack_public_path__ + "static/57-fbf187bdd349cc674fd06e620e4ffee0.jpg";